module.exports = __webpack_public_path__ + "img/Group-4214.a1181cef.svg";